import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '@vgw/tailwind-merger'
import { ButtonBase, ButtonBaseProps } from './button-base'

const buttonOutlinedVariants = cva(
  [
    'border-gradient-mask',
    'bg-transparent',
    'before:bg-linear-to-b',
    'before:p-(--border-width-button-outlined)',
    'disabled:before:from-transparent',
    'disabled:before:to-transparent',
  ],
  {
    variants: {
      variant: {
        primary: [
          'rounded-button-outlined',
          'text-button-outlined-content',
          'hover:bg-button-outlined-surface-hover',
          'active:bg-button-outlined-surface-active',
          'active:opacity-92',
          'disabled:bg-surface-disabled',
          'disabled:text-content-disabled',
          'disabled:rounded-button-outlined',
          'disabled:active:opacity-100',
          'before:rounded-button-outlined',
          'before:from-button-outlined-border-primary-0',
          'before:to-button-outlined-border-primary-100',
        ],
        secondary: [],
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
)

export type ButtonOutlinedProps = ButtonBaseProps

export const ButtonOutlined = forwardRef<
  HTMLButtonElement,
  ButtonOutlinedProps
>(({ className, variant = 'primary', ...props }: ButtonOutlinedProps, ref) => (
  <ButtonBase
    {...props}
    className={cn(buttonOutlinedVariants({ variant, className }))}
    variant={variant}
    ref={ref}
  />
))

ButtonOutlined.displayName = 'ButtonOutlined'
